import Timer from '@/pages/owner/Timer';

export default function CustomerTimer() {
    return <Timer />;
}
